import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const baseNav = [
  { to: '/dashboard', label: '概览' },
  { to: '/fans', label: '粉丝' },
  { to: '/notifications', label: '通知' },
  { to: '/accounts', label: '公众号' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navItems = user?.role === 'super' ? [...baseNav, { to: '/super', label: '超管' }] : baseNav;
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-md bg-brand-600 text-white grid place-items-center font-bold">Q</div>
            <span className="font-semibold text-slate-800">群柚租户管理台</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-600">
            <span>
              {user?.username}
              {user?.role === 'super' && <span className="ml-1 rounded bg-amber-100 px-1.5 py-0.5 text-xs text-amber-700">超管</span>}
            </span>
            <button className="btn-ghost" onClick={() => logout()}>退出</button>
          </div>
        </div>
      </header>
      <div className="mx-auto flex w-full max-w-6xl flex-1 gap-6 px-6 py-6">
        <nav className="w-40 shrink-0">
          <ul className="space-y-1">
            {navItems.map((it) => (
              <li key={it.to}>
                <NavLink
                  to={it.to}
                  className={({ isActive }) =>
                    `block rounded-md px-3 py-2 text-sm ${
                      isActive ? 'bg-brand-50 text-brand-700 font-medium' : 'text-slate-600 hover:bg-slate-100'
                    }`
                  }
                >
                  {it.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
